export default {
  dark: 'Mørkt',
  light: 'Lyst',
};
